import type { IServicesCollection } from 'src/packages/di';

import { AnomalyNotificationsService } from './AnomalyNotificationsService';
import type { IAnomalyNotificationsService } from './IAnomalyNotificationsService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    anomalyNotificationsService: IAnomalyNotificationsService;
  }
}

export function addAnomalyNotificationsService(di: IServicesCollection) {
  const notificationsService = new AnomalyNotificationsService();
  di.addSingleton('anomalyNotificationsService', notificationsService);
}
